import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    getAdminEmpresa, getFinanceiroCaixa,
    getFinanceiroAgencia,
    getFiscalEmbarque,
    getOperadorEmpresa,
    getPerfisVendedores, getVendedorAgencia, getVendedorEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import { getFinanceiroEmpresa } from '../../security/securityContext';

export class MenuEncomendas extends Component {

    render() {
        return (
            <div className="area-home">
                <Titulo texto="Encomendas Vexado Express" urlRetorno="/gestao-empresa" />
                <div className="vx-menu-bag">

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-cadastro-encomenda" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">add</span>
                                </div>
                                <div className="vx-menu-bag-label">Nova encomenda</div>
                            </div>
                        </Link>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroCaixa(this.props.empresaSelecionada.id),
                        getFinanceiroAgencia(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                        getVendedorAgencia(this.props.empresaSelecionada.id),
                        getVendedorEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-encomendas" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">list</span>
                                </div>
                                <div className="vx-menu-bag-label">Gerenciar encomendas</div>
                            </div>
                        </Link>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-configuracao-encomendas" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">tune</span>
                                </div>
                                <div className="vx-menu-bag-label">Configuração de encomendas</div>
                            </div>
                        </Link>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-confirmar-entrega-encomendas" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">check_circle</span>
                                </div>
                                <div className="vx-menu-bag-label">Informar entregas</div>
                            </div>
                        </Link>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getVendedorEmpresa(this.props.empresaSelecionada.id),
                        getVendedorAgencia(this.props.empresaSelecionada.id),
                        getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-registrar-entrega-encomenda" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">assignment_turned_in</span>
                                </div>
                                <div className="vx-menu-bag-label">Registrar entrega de encomenda</div>
                            </div>
                        </Link>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-mdfe" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">send</span>
                                </div>
                                <div className="vx-menu-bag-label">Transmissão MDF-e</div>
                            </div>
                        </Link>
                    </Autorizacao>

                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}


export default withRouter(connect(mapStateToProps)(MenuEncomendas));
